import { useBoundStore } from '../../../../stores';
import { Delete, Edit, LinkOff, Visibility } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import PermissionToRender from '../../../../components/Permission/PermissionToRender';
import { useNavigate } from 'react-router-dom';

function Columns(handleDelete, handleRelation) {
  const navigate = useNavigate();
  const textPool = useBoundStore((state) => state.textPool);
  const toggleLeftDrawer = useBoundStore((state) => state.toggleLeftDrawer);

  return [
    { field: 'appointedName', headerName: 'İsim', width: 120 },
    { field: 'appointedSurname', headerName: 'Soyisim', width: 120 },
    { field: 'appointedPhonenumber', headerName: 'GSM', width: 120 },
    {
      field: 'deviceId.imei',
      headerName: "Cihaz IMEI",
      width: 180,
      renderCell: (data) => {
        return data.row?.deviceId?.imei ? (
          data.row.deviceId.imei
        ) : (
          <span className="font-bold">-</span>
        );
      },
    },
    {
      field: 'companyId.companyName',
      headerName: "Şirket Adı",
      width: 180,
      renderCell: (data) => {
        return data.row?.companyId?.companyName ? (
          data.row?.companyId?.companyName
        ) : (
          <span className="font-bold">-</span>
        );
      },
    },
    {
      field: 'productId.productName',
      headerName: "Ürün Adı",
      width: 100,
      renderCell: (data) => {
        return data.row?.productId?.productName ? (
          data.row?.productId?.productName
        ) : (
          <span className="font-bold">-</span>
        );
      },
    },
    {
      field: 'userId.username',
      headerName: "Teslim Eden",
      width: 170,
      renderCell: (data) => {
        return data.row.userId.username ? (
          data.row.userId.name + ' ' + data.row.userId.surname
        ) : (
          <span className="font-bold">-</span>
        );
      },
    },

    // {
    //   field: 'vehicle_Id',
    //   headerName: textPool['Araç Plaka'],
    //   width: 200,
    //   renderCell: (data) => {
    //     return data.row.vehicle_Id ? (
    //       data.row.vehicle_Id
    //     ) : (
    //       <span className="font-bold">Eşleşme Yok</span>
    //     );
    //   },
    // },
    /* { field: 'dataProtocol', headerName: 'Protokol', width: 150 },
    { field: 'dataProtocolVersion', headerName: 'Protokol Versiyonu', width: 150 },
    { field: 'company', headerName: 'Şirket', width: 150 },  */
    {
      field: 'createdAt',
      headerName: textPool['Oluşturma Tarihi'],
      width: 150,
      notFilter: true,
      renderCell: (data) =>
        data.row.createdAt ? (
          <div>
            {data?.row?.createdAt
              ? new Date(data?.row?.createdAt).toLocaleString('tr')
              : ''}
          </div>
        ) : (
          <span className="font-bold">Eşleşme Yok</span>
        ),
    },
    {
      field: 'actions',
      headerName: 'İşlemler',
      width: 100,
      sortable: false,
      align: 'center',
      renderCell: (params) => {
        return (
          <div className="flex flex-row">
            {/* <PermissionToRender roleCanView={'KV_SUPERUSER'}>
              <IconButton
                onClick={() => {
                  navigate(
                    `/definitions/devices/device-record/${params.row.device_Id}`,
                  );
                }}
              >
                <Visibility />
              </IconButton>
            </PermissionToRender> */}

            <IconButton
              onClick={() => {
                navigate(`/definitions/assignments/#${params.row.id}`);
                toggleLeftDrawer();
              }}
            >
              <Edit />
            </IconButton>


            {/* <IconButton
              disabled={!params.row.id}
              onClick={() => handleRelation(params.row)}
            >
              <LinkOff />
            </IconButton> */}

            <IconButton onClick={() => handleDelete(params.row)}>
              <Delete />
            </IconButton>
          </div>
        );
      },
    },
  ];
}
export { Columns as columns };
